import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";

import Home from './Pages/Home';
import About from './Pages/About';
import Header from './Component/Header';


import Footter from './Component/Footter';

import Login from './Pages/Login';

import Showadmin from './Pages/creditbank/Showadmin';
import Notfound from './Pages/creditbank/Notfound';
import Curriculum from './Pages/creditbank/Curriculum';
import Teacher from './Pages/creditbank/Teacher';
import Reportcurriculumall from './Pages/creditbank/Reportcurriculumall';
import Register from './Pages/Register';
import Studentmain from './Pages/student/Studentmain';
import Student from './Pages/creditbank/Student';
import Studentcheckregister from './Pages/student/Studentcheckregister';
import Studentportfolio from './Pages/student/Studentportfolio';
import Teachermain from './Pages/teacher/Teachermain';
import Results from './Pages/teacher/Results';
import Studentgradereport from './Pages/student/Studentgradereport';
import Teachercuriculum from './Pages/teacher/Teachercuriculum';
import Admincumain from './Pages/admincu/Admincumain';
import Admindeanmain from './Pages/admindean/Admindeanmain';
import Admindeangrade from './Pages/admindean/Admindeangrade';
import Certificase from './Pages/creditbank/Certificase';
import Reportnumfaculty from './Pages/creditbank/Reportnumfaculty';
import Register2 from './Pages/Register2';
import Curriculumshortterm from './Pages/creditbank/Curriculumshortterm';
import Teachershortterm from './Pages/teacher/Teachershortterm';
import Curriculumshort from './Pages/creditbank/Curriculumshort';
import Admincumainshort from './Pages/admincu/Admincumainshort';
import Teachermainshort from './Pages/creditbank/Teachermainshort';
import Teachercuriculumshort from './Pages/teacher/Teachercuriculumshort';
import Resultsshort from './Pages/creditbank/Resultsshort';
import Curriculumshorttermforadmin from './Pages/creditbank/Curriculumshorttermforadmin';
import Reportcurriculummooc from './Pages/creditbank/Reportcurriculummooc';









export default class Routes extends Component {
    render() {
        return (
            <>
    
            <Router basename="creditbank" >
                <Header />
                <br/>
                <div className="content-container "> 
                            <Switch>
                                

                                    <Route exact path="/" component={Home} />
                                  
                                
                                    <Route exact path="/Showadmin" component={Showadmin} />
                                    <Route exact path="/Login" component={Login} />
                                    <Route exact path="/Curriculum" component={Curriculum} />
                                    <Route exact path="/Teacher" component={Teacher} />
                                    <Route exact path="/Reportcurriculumall" component={Reportcurriculumall} />
                                    <Route exact path="/Register" component={Register} />
                                    <Route exact path="/Studentmain" component={Studentmain} />
                                    <Route exact path="/Student" component={Student} />
                                    <Route exact path="/Studentcheckregister" component={Studentcheckregister} />
                                    <Route exact path="/Studentportfolio" component={Studentportfolio} />
                                    <Route exact path="/Teachermain" component={Teachermain} />
                                    <Route exact path="/Results" component={Results} />
                                    <Route exact path="/Studentgradereport" component={Studentgradereport} />
                                    <Route exact path="/Teachercuriculum/:id" component={Teachercuriculum} />
                                    <Route exact path="/Admincumain" component={Admincumain} />
                                    <Route exact path="/Admindeanmain" component={Admindeanmain} />
                                    <Route exact path="/Admindeangrade" component={Admindeangrade} />
                                    <Route exact path="/Certificase" component={Certificase} />
                                    <Route exact path="/Reportnumfaculty" component={Reportnumfaculty} />
                                    <Route exact path="/Register2" component={Register2} />
                                    <Route exact path="/Curriculumshortterm" component={Curriculumshortterm} />
                                    <Route exact path="/Teachershortterm" component={Teachershortterm} />
                                    <Route exact path="/Curriculumshort" component={Curriculumshort} />
                                    <Route exact path="/Admincumainshort" component={Admincumainshort} />
                                    <Route exact path="/Teachermainshort" component={Teachermainshort} />
                                    <Route exact path="/Teachercuriculumshort/:id/:id2" component={Teachercuriculumshort} />
                                    <Route exact path="/Resultsshort" component={Resultsshort} />
                                    <Route exact path="/Curriculumshorttermforadmin" component={Curriculumshorttermforadmin} />
                                    <Route exact path="/Reportcurriculummooc" component={Reportcurriculummooc} />

                                    <Route render={function () {return <Notfound/> }} />
                                </Switch> <br/>
                </div>

               <footer className="footer--pin">
                <Footter />
               </footer>
               
            </Router>
                 
          </>  
        )
    }
}
